<ng-template #timeSpotsTemplate>
  <div class="vertical-time-slots" #timeSlots>
    <div
      class="vertical-time-slots__cell"
      #timeSpotVerticalCell
      *ngFor="let timeSpot of timeSpots"
    ></div>
    <!-- Spacer to represent the size of the day info element -->
    <div class="vertical-time-slots__spacer" #requestDayInfoWidth></div>
    <div
      class="vertical-time-slots__container"
      [ngStyle]="{ flex: '0 0 ' + rowWidth + 'px' }"
    >
      <!--
      Left distance for the time labels is calculated as follows:
      rowWidth is the width of the row
      112 is the width of the info cell
      22 is the width of the time label
      24 is the number of hours in a day
      4 is the left margin of the time label
      -->
      <!-- [ngStyle]="{ left: ((rowWidth - (112 + 22)) / 24) * i + 4 + 'px' }" -->
      <div
        class="vertical-time-slots__slot"
        #timeSpot
        *ngFor="let timeSpot of timeSpots"
      >
        <div
          class="vertical-time-slots__label"
          [ngClass]="{ 'highlighted-info': timeSpot.isCurrentHour }"
          #timeSpotLabel
        >
          {{ timeSpot.label }}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="row">
  <div class="col-lg-12 d-flex flex-column">
    <div class="calendar-toolbar mb-3">
      <div class="d-flex justify-content-left align-items-center">
        <div class="material-symbols-outlined calendar-toolbar__icon">
          calendar_clock
        </div>
        <div class="station-info d-flex align-items-center">
          <div class="station-info__logo">
            <img
              [src]="getLogoSrc(data.channel.logo_id)"
              class="station-logo-image"
              alt="station-logo-preview"
              data-testId="calendar-station-logo"
            />
          </div>
          <div class="station-info__label-container">
            <div class="station-info__name" data-testId="calendar-station-name">
              {{ data.channel.name }}
            </div>
            <div
              class="station-info__provider"
              data-testId="calendar-station-provider"
            >
              {{ data.channel.provider }}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <button
          class="calendar-toolbar__today-button"
          mat-button
          color="basic"
          (click)="onTodayClick()"
          data-testId="calendar-today-button"
        >
          <div class="material-symbols-outlined">calendar_clock</div>
          TODAY
        </button>
      </div>
      <div class="d-flex justify-content-end">
        <app-add-button
          data-testid="epg-add-episode-dialog"
          matTooltip="Add episode"
          [disabled]="readOnlyMode"
          (onClick)="openAddEpisodeDialog()"
        >
        </app-add-button>
      </div>
    </div>
    <div class="d-flex flex-column position-relative">
      <div class="calendar-top-left-cover" #requestDayInfoWidth></div>
      <div class="day-schedule__scrollable-view" #scrollView>
        <div
          class="vertical-time-slots__cell"
          #calendarVerticalCell
          *ngFor="let timeSpot of timeSpots"
        ></div>
        <div class="day-schedule__noon-line-indicator" #noonLineIndicator></div>
        <ng-container *ngTemplateOutlet="timeSpotsTemplate"></ng-container>
        <ng-container *ngFor="let schedule of scheduleList; index as i">
          <div class="day-schedule__row" #episodeRow>
            <!-- apply class .highlighted-info to the first day -->
            <div
              class="day-schedule__day-info"
              [ngClass]="{ 'highlighted-info': i === 0 }"
              #scheduleWeekDayBlock
            >
              <div class="day-schedule__day-info__weekday">
                {{ schedule.weekDay }}
              </div>
              <div class="day-schedule__day-info__month">
                {{ schedule.month }}
              </div>
              <div class="day-schedule__day-info__number">
                {{ schedule.day }}
              </div>
              <div class="day-schedule__day-info__year">
                {{ schedule.year }}
              </div>
            </div>

            <div
              #episodeRowContents
              class="day-schedule__row__contents"
              [ngStyle]="{
                flex: '0 0 ' + rowWidth + 'px'
              }"
            >
              <ng-container *ngFor="let program of schedule.episodes">
                <div
                  class="day-schedule__program"
                  [ngStyle]="{
                    width: program.position.width * rowWidth + 'px',
                    transform:
                      'translate3d(' +
                      program.position.distance * rowWidth +
                      'px,0,0)'
                  }"
                >
                  <app-schedule-program
                    (onEdit)="openEditEpisodeDetailsDialog($event.program)"
                    [program]="program"
                    class="flex-fill"
                    [readOnly]="readOnlyMode"
                  ></app-schedule-program>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
